module.exports = __webpack_public_path__ + "static/media/logo-on-dark-mobile.90b69231.svg";